<template>
  <div class="mv3 main-container">
    <div class="flex justify-center">
      <router-link to="/" class="flex flex-row items-center justify-center w-50 f6 glow hover-bg-blue hover-white link ba ph3 pv2 mb2 dib blue pointer br2">
        <i class="f4 fas fa-caret-left"></i>
        <span class="ph2">Back to the Hymnals</span>
      </router-link>
    </div>
    <core-hymnal-header :hymnalName="hymnalName" />
    <div class="flex flex-row-ns flex-column ma3 items-center">
      <!-- Mobile view -->
      <div id="mobile" class="dn-ns flex flex-row items-center justify-center">
        <input v-model.number="pageInput" class="h3 w3 pa2 bt bl bb br--left br2 b--moon-gray gray f2 fl w-25 mv4" type="number" placeholder="Pg#">
        <router-link
          :to="{
          name: 'hymn-detail',
          params: {
            page: hymns[hymnalUrl] = pageInput,
            hymnal: hymnalUrl,
            hymns: hymns,
            hymnalName: hymnalName
            }
          }"
          class="flex h3 w3 bn br--right br2 pa1 f3 glow bg-blue hover-bg-white link white pointer items-center justify-center"
          >Go
          </router-link>
      </div>
      <!-- Desktop View -->
      <input id="desktop" v-model.number="pageInput" class="dn dib-ns h2 pa2 bt bl bb br--left b--moon-gray br2 gray f4 fl w-25 mv4" type="number" placeholder="Pg #">
      <!-- <div @click="findByPage" class="dn flex-ns h2 w3 bn br--right br2 pa1 f5 bg-blue dim link white pointer items-center justify-center mr2">Go</div> -->
      <router-link
        :to="{
          name: 'hymn-detail',
          params: {
            page: hymns[hymnalUrl] = pageInput,
            hymnal: hymnalUrl,
            hymns: hymns,
            hymnalName: hymnalName
          }
        }"
        class="dn flex-ns h2 w3 bn br--right br2 pa1 f5 bg-blue dim link white pointer items-center justify-center mr2"
        :hymnal="hymnalUrl"
        :hymns="hymns">
        Go
      </router-link>
      <input v-model="titleInput" v-if="checked" class="h2 pa2 gray ba br2 b--moon-gray f4 fl w-75" type="text" placeholder="Search by title">
    </div>
    <div v-if="checked" class="mb5">
      <li v-for="hymn in hymns && searchByTitle" :key="hymn.id" class="db pa0 mh0 justify-between f6 f5-ns">
        <router-link
          :to="{
            name: 'hymn-detail',
            params: {
              page: hymn[hymnalUrl],
              hymnal: hymnalUrl,
              hymns: hymns,
              hymnalName: hymnalName
            }
          }"
          class="link dim gray hover-blue"
          :hymnal="hymnalUrl"
          :hymns="hymns"
        >
          <div class="flex flex-row bb b--moon-gray items-center tl">
            <p v-if="hymn.approved === true" class="ml3 mv1 dot bg-green"></p>
            <p v-if="hymn.approved === false" class="ml3 mv1 dot bg-light-red"></p>
            <p v-if="hymn.approved === null" class="ml3 mv1 dot bg-silver"></p>
            <p class="mh3 mv1 w1">{{ hymn[hymnalUrl]}}</p>
            <p class="mh0 ml3-ns mv1">{{ hymn.title }}</p>
            <i v-if="hymn.choir && hymnalUrl === 'tccog2010'" class="fas fa-users mh1 mv1 f7 blue"></i>
          </div>
        </router-link>
      </li>
    </div>
    <div class="dn-ns flex flex-row items-center fixed bottom-0 bg-white w-100 bt b--gray moon-gray ph2" @click="checked = !checked">
      <div class="checkbox">
        <input type="checkbox" v-model="checked">
      </div>
      <div class="pa2">List hymns or search by title</div>
    </div>
  </div>
</template>

<script>
import hymns from '@/assets/hymnals.json'
import { mapGetters } from 'vuex'

export default {
  name: 'hymnal',
  props: {
    hymnalUrl: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      hymns: hymns,
      hymnalName: '',
      checked: true,
      pageInput: '',
      titleInput: ''
    }
  },
  computed: {
    ...mapGetters({
      hymnals: 'hymnals/hymnals'
    }),
    searchByTitle () {
      return this.hymns.filter(hymn => {
        return hymn['title'].toLowerCase().indexOf(this.titleInput.toLowerCase()) > -1
      })
    }
  },
  created: function () {
    let { hymns, hymnalUrl } = this
    this.hymns = this.getFilteredHymns(hymns, hymnalUrl)
    this.hymnalName = this.hymnalUrl
  },
  methods: {
    getFilteredHymns (hymnsList, hymnalUrl) {
      return hymnsList
        .filter(hymn => hymn[hymnalUrl])
        .sort(function (a, b) {
          return a[hymnalUrl] - b[hymnalUrl]
        })
    },
    findByPage () {
      let { pageInput } = this
      this.$router.push({
        name: 'hymn-detail',
        params: {
          page: pageInput
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-input {
  width: 100px;
}
</style>
